<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32 <lg:flex-col <lg:gap-32 <lg:py-16">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.about.content1.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.about.content1.item1.title')" :description="$t('header.about.content1.item1.desc')" to="/about/introduction" />
        </li>
        <li>
          <ListItem :title="$t('header.about.content1.item2.title')" :description="$t('header.about.content1.item2.desc')" to="/about/structure" />
        </li>
        <li>
          <ListItem :title="$t('header.about.content1.item3.title')" :description="$t('header.about.content1.item3.desc')" to="/about/council" />
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">&nbsp;</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.about.content2.item1.title')" :description="$t('header.about.content2.item1.desc')" to="/about/toc" />
        </li>
        <li>
          <ListItem :title="$t('header.about.content2.item2.title')" :description="$t('header.about.content2.item2.desc')" to="/about/security" />
        </li>
        <li>
          <ListItem :title="$t('header.about.content2.item3.title')" :description="$t('header.about.content2.item3.desc')" to="/about/cloud" />
        </li>
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
